export default "__VITE_ASSET__LXPXqrRe__"